<template>
  <!--dimmitend-->
  <div class="row">
    <div class="col-xs-12" v-if="subscriptionType == 'student'">
      <p v-html="d.ftfaStudentIntro"></p>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12">
      <div class="field-wrapper half">
        <label>{{ d.unemploymentInsuranceGraduateLabel }}*</label>
        <div class="list-inline">
          <label class="radio">
            <input type="radio" name="dim-student" required="true" v-model="values.dimStudent"
              @change="ResetValidation('dimStudent')" value="ja" />
            <span class="checklabel">{{ d.generalYes }}</span>
            <span class="checkmark"></span>
          </label>
          <label class="radio">
            <input type="radio" name="dim-student" required="true" v-model="values.dimStudent"
              @change="ResetValidation('dimStudent')" value="nej" />
            <span class="checklabel">{{ d.generalNo }}</span>
            <span class="checkmark"></span>
          </label>

          <div class="input-errors" v-for="error of v$.values.dimStudent.$errors" :key="error.$uid">
            <!-- <div>{{ error }}</div> -->
            <div v-if="error.$validator == 'required' && !error.$response" class="error-msg">
              {{ d.errorrecentgraduate }}
            </div>
          </div>

          <div class="row">
            <HelperTip class="col-md-6" :rte="d.helpertiprecentgraduate" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">

    <div class="col-xs-12" v-if="dimYes">
      <EducationDetails v-if="!(subscriptionType == 'student' && values.educationType == 'videregaaendeuddannelse')"
        :ask-for-insurance="!(subscriptionType == 'student' && values.educationType == 'videregaaendeuddannelse')">
      </EducationDetails>
    </div>

    <!--rettigheder-->
    <div class="col-xs-12" v-if="dimYes || subscriptionType == 'student'">
      <div class="field-wrapper half">
        <label>{{ d.unemploymentInsuranceClaimYourRightsLabel }}*</label>

        <div class="list-inline">
          <label class="radio">
            <input type="radio" name="dim-rights" required="true" v-model="values.dimRights"
              @change="ResetValidation('dimRights')" value="ja" />
            <span class="checklabel">{{ d.generalYes }}</span>
            <span class="checkmark"></span>
          </label>
          <label class="radio">
            <input type="radio" name="dim-rights" required="true" v-model="values.dimRights"
              @change="ResetValidation('dimRights')" value="nej" />
            <span class="checklabel">{{ d.generalNo }}</span>
            <span class="checkmark">
            </span>
          </label>

          <div class="input-errors" v-for="error of v$.values.dimRights.$errors" :key="error.$uid">
            <!-- <div>{{ error }}</div> -->
            <div v-if="error.$validator == 'required' && !error.$response" class="error-msg">
              {{ d.errorgraduatesecurerights }}
            </div>
          </div>

          <div class="row">
            <HelperTip class="col-md-6" :rte="d.unemploymentInsuranceClaimYourRightsHelperTip" />
          </div>

          <div class="row">
            <!-- <HelperTip class="col-md-6" rte="Vælg JA for at sikre din ret til dagpenge efter endt uddannelse - også selvom du i øjeblikket har job. Din dagpengeret kræver også, at du har været medlem i et år til den tid, og du husker at melde dig ledig på jobnet.dk. Har du været medlem i mindre end et år, har du ret til dagpenge en måned efter, du afslutter din uddannelse. Hvis du har haft en samlet indkomst fra arbejde på 243.996 kr. (2021) eller mere de sidste tre år, samtidig med du har været medlem af en a-kasse. For så kan det muligvis betale sig for dig IKKE at sikre din dagpengeret. Ring og spørg a-kassen på tlf.: 89 38 39 70" /> -->
            <div v-if="noRights" class="col-xs-12">
              <label class="checkbox-slider">
                <input type="checkbox" :value="true" v-model="values.dimRightsNO" />
                <span class="label" v-html="d.unemploymentInsuranceStudentConfirmYourChoice"></span><span
                  class="gfx"></span>
              </label>
              <div class="input-errors" v-for="error of v$.values.dimRightsNO.$errors" :key="error.$uid">
                <!-- <div>{{ error }}</div> -->
                <div v-if="error.$validator == 'required' && !error.$response" class="error-msg">
                  {{ d.ftfaMustAccept }}
                </div>
              </div>
              <p v-html="d.unemploymentInsuranceStudentConfirmYourChoiceNo"></p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- kan du sige ja til...-->
    <div class="col-xs-12" v-if="subscriptionType == 'student'">
      <div class="field-wrapper half">
        <label>{{ d.unemploymentInsuranceDoYouAgreeLabel }}*</label>

        <p v-html="d.unemploymentInsuranceStudentDoYouAgree"></p>

        <div class="list-inline">
          <label class="radio">
            <input type="radio" name="dim-student-yesno" required="true" v-model="values.dimStudentYesno"
              @change="ResetValidation('dimStudentYesno')" value="ja" />
            <span class="checklabel">{{ d.generalYes }}</span>
            <span class="checkmark"></span>
          </label>
          <label class="radio">
            <input type="radio" name="dim-student-yesno" required="true" v-model="values.dimStudentYesno"
              @change="ResetValidation('dimStudentYesno')" value="nej" />
            <span class="checklabel">{{ d.generalNo }}</span>
            <span class="checkmark"></span>
          </label>
        </div>

        <div class="input-errors" v-for="error of v$.values.dimStudentYesno.$errors" :key="error.$uid">
          <!-- <div>{{ error }}</div> -->
          <div v-if="error.$validator == 'required' && !error.$response" class="error-msg">
            {{ d.errorgraduatefreemembershipincome }}
          </div>
        </div>
      </div>
    </div>

    <!-- gratis medlemsskab -->
    <div class="col-xs-12" v-if="values.dimStudentYesno == 'nej'">
      <div class="field-wrapper half">
        <label>{{ d.unemploymentInsuranceApplyForFreeMembershipLabel }}*</label>
        <div class="list-inline">
          <label class="radio">
            <input type="radio" name="dim-student-free" required="true" v-model="values.dimStudentFree"
              @change="ResetValidation('dimStudentFree')" value="ja" />
            <span class="checklabel">{{ d.generalYes }}</span>
            <span class="checkmark"></span>
          </label>
          <label class="radio">
            <input type="radio" name="dim-student-free" required="true" v-model="values.dimStudentFree"
              @change="ResetValidation('dimStudentFree')" value="nej" />
            <span class="checklabel">{{ d.generalNo }}</span>
            <span class="checkmark"></span>
          </label>
        </div>
        <p v-if="values.dimStudentFree == 'nej'">
          {{ d.ftfaNoMembershipOnPublicBenefits }}
        </p>
        <div class="input-errors" v-for="error of v$.values.dimStudentFree.$errors" :key="error.$uid">
          <!-- <div>{{ error }}</div> -->
          <div v-if="error.$validator == 'required' && !error.$response" class="error-msg">
            {{ d.errorgraduatefreemembership }}
          </div>
        </div>
      </div>
    </div>

    <!-- offentlige ydelser -->
    <div v-if="values.dimStudentFree == 'ja'">
      <div class="col-xs-12">
        <div class="field-wrapper half">
          <label>{{ d.unemploymentInsuranceReceivingPublicBenefitsLabel }}*</label>
          <div class="list-inline">
            <label class="radio">
              <input type="radio" name="dim-student-pension" required="true" v-model="values.dimStudentPension"
                @change="ResetValidation('dimStudentPension')" value="ja" />
              <span class="checklabel">{{ d.generalYes }}</span>
              <span class="checkmark"></span>
            </label>
            <label class="radio">
              <input type="radio" name="dim-student-pension" required="true" v-model="values.dimStudentPension"
                @change="ResetValidation('dimStudentPension')" value="nej" />
              <span class="checklabel">{{ d.generalNo }}</span>
              <span class="checkmark"></span>
            </label>
          </div>

          <p v-html="d.unemploymentInsuranceStudentFreeMembership"></p>
          <p v-if="values.dimStudentPension == 'ja'" v-html="d.unemploymentInsuranceStudentFreeMembershipBenefits"></p>

          <div class="input-errors" v-for="error of v$.values.dimStudentPension.$errors" :key="error.$uid">
            <!-- <div>{{ error }}</div> -->
            <div v-if="error.$validator == 'required' && !error.$response" class="error-msg">
              {{ d.errorgraduatepublicsupport }}
            </div>
          </div>
        </div>
      </div>

      <div class="col-xs-12">
        <div class="field-wrapper half">
          <label>{{
            values.isTrainee
              ? d.unemploymentInsuranceBenefitsApartFromTraineeSalaryLabel
              : d.unemploymentInsuranceStudentSalaryThroughoutEducation
          }}*</label>
          <div class="list-inline">
            <label class="radio">
              <input type="radio" name="dim-student-su" required="true" v-model="values.dimStudentSu"
                @change="ResetValidation('dimStudentSu')" value="trorIkkeSu" />
              <span class="checklabel">{{
                values.isTrainee
                  ? d.unemploymentInsuranceStudentTraineeNoExtraIncome
                  : d.unemploymentInsuranceStudentNoExtraIncome
              }}</span>
              <span class="checkmark"></span>
            </label>
            <label class="radio">
              <input type="radio" name="dim-student-su" required="true" v-model="values.dimStudentSu"
                @change="ResetValidation('dimStudentSu')" value="trorSu" />
              <span class="checklabel">{{
                values.isTrainee
                  ? d.unemploymentInsuranceStudentTraineeExtraIncome
                  : d.unemploymentInsuranceStudentExtraIncome
              }}</span>
              <span class="checkmark"></span>
            </label>
          </div>
          <p v-if="values.dimStudentSu == 'trorSu' && !values.isTrainee">
            {{ d.ftfaFreeMemberWarnStudent }}
          </p>
          <p v-if="values.dimStudentSu == 'trorSu' && values.isTrainee" v-html="d.ftfaFreeMemberWarnTrainee">

          </p>
          <div class="input-errors" v-for="error of v$.values.dimStudentSu.$errors" :key="error.$uid">
            <!-- <div>{{ error }}</div> -->
            <div v-if="error.$validator == 'required' && !error.$response" class="error-msg">
              {{ d.errorgraduatesupportentitled }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- bopæl -->
    <div class="col-xs-12" v-if="(values.dimStudentYesno == 'nej') || (values.dimStudent == 'ja')">
      <div class="field-wrapper half">
        <label>{{ d.unemploymentInsuranceDidYouLiveInDenmarkEducationStartLabel }}*</label>
        <div class="list-inline">
          <label class="radio">
            <input type="radio" name="dim-student-denmark" required="true" v-model="values.dimStudentInDenmark"
              @change="ResetValidation('dimStudentInDenmark')" value="ja" />
            <span class="checklabel">{{ d.generalYes }}</span>
            <span class="checkmark"></span>
          </label>
          <label class="radio">
            <input type="radio" name="dim-student-denmark" required="true" v-model="values.dimStudentInDenmark"
              @change="ResetValidation('dimStudentInDenmark')" value="nej" />
            <span class="checklabel">{{ d.generalNo }}</span>
            <span class="checkmark"></span>
          </label>
          <p v-if="values.dimStudentInDenmark == 'nej'">
            {{ d.unemploymentInsuranceStudentResidenceNotDk }}
          </p>
        </div>

        <div class="input-errors" v-for="error of v$.values.dimStudentInDenmark.$errors" :key="error.$uid">
          <!-- <div>{{ error }}</div> -->
          <div v-if="error.$validator == 'required' && !error.$response" class="error-msg">
            {{ d.errorgraduateresidenceeducationstart }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import useVuelidate from "@vuelidate/core";
import HelperTip from "../FormComponents/HelperTip.vue";
import EducationDetails from "./EducationDetails.vue";
export default {
  components: {
    HelperTip,
    EducationDetails,
  },
  setup() {
    // we use vuelidate for validation
    // https://vuelidate-next.netlify.app/
    return { v$: useVuelidate({ $lazy: true }) };
  },
  data: (instance) => {
    return {
      subscriptionType: instance.store.subscriptionType,
      values: instance.store[instance.store.currentCulture].values.personalDetails,
      product: instance.store[instance.store.currentCulture].values.productDetails,
      d: instance.store[instance.store.currentCulture].dictionary,
      culture: instance.store.currentCulture,
      visual: instance.store[instance.store.currentCulture].values.visualDetails,
    };
  },
  methods: {
    ResetValidation(field) {
      console.log("field", field);

      switch (field.toLowerCase()) {
        case "dimstudent":
          this.v$.values.dimRights.$reset();
          this.v$.values.dimStudent.$reset();
          this.v$.values.dimStudentFree.$reset();
          this.v$.values.dimStudentInDenmark.$reset();
          this.v$.values.dimStudentPension.$reset();
          this.v$.values.dimStudentSu.$reset();
          this.v$.values.dimStudentYesno.$reset();
          break;
        case "dimstudentyesno":
          this.v$.values.dimStudentFree.$reset();
          break;
        case "dimstudentfree":
          this.v$.values.dimStudentPension.$reset();
          this.v$.values.dimStudentSu.$reset();
          break;
        default:
          // NOTHING YET
          break;
      }
    },
  },
  computed: {
    dimYes() {
      return this.values.dimStudent == "ja";
    },
    noRights() {
      return this.values.dimRights == "nej";
    },
  },
  validations() {
    return this.validations.dimStudent;
  },
};
</script>

<style scoped lang="postcss">
.input-errors {
  color: red;
  margin-top: -15px;

  +.input-errors {
    margin-top: 0;
  }
}
</style>
